/**
 * Original Author: Kody Crossman
 * Original Team: BFFs
 */
/**
 * Takes an amount and an optional unit and returns a string with the unit
 * @param {string | number} str
 * @param {string} unit
 */
export function convertToUnit(str, unit = 'px') {
  if (str == null || str === '') {
    return undefined;
  } else if (isNaN(+str)) {
    return String(str);
  } else {
    return `${Number(str)}${unit}`;
  }
}

export function unescapeHtmlEntities(str) {
  return String(str)
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&#39/g, "'");
}
